import { HTMLProps } from 'react';
import { isCORS, isSeamless } from 'utility/functions';

export const isAllowed = isCORS() ? false : true;
export const isRequired = isSeamless();

export interface SeamlessHomeLinkProps extends HTMLProps<HTMLElement> {
  url?: string | null;
}

export { SeamlessHomeLink } from './SeamlessHomeLink';

export interface SeamlessHomeWrapperProps extends HTMLProps<HTMLElement> {
  children?: React.ReactNode | JSX.Element | string | number;
}

export { SeamlessHomeWrapper } from './SeamlessHomeWrapper';
